export const handlePageChange = (newPage, setParams) => {
    setParams((prev) => ({ ...prev, page: newPage }));
};

export const handleChangeRowsPerPage = (event, setParams) => {
    const value = parseInt(event.target.value, 10);
    setParams((prev) => ({ ...prev, limit: value, pageSize: value, page: 0 }));
};
